import { render, staticRenderFns } from "./FixedCoverage.vue?vue&type=template&id=31894e30&scoped=true"
import script from "./FixedCoverage.vue?vue&type=script&lang=js"
export * from "./FixedCoverage.vue?vue&type=script&lang=js"
import style0 from "./FixedCoverage.vue?vue&type=style&index=0&id=31894e30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31894e30",
  null
  
)

export default component.exports